import { ColumnSelectionFilter } from './ColumnSelectionFilter';
import {
  useUserTableStore,
  initialUserColumns,
} from 'views/pages/Admin/User/Filters/filters.store';
import { Button } from '@mui/material';
import { ColumnPreferencesConfig } from '@common/types';

type UserColumnKey =
  | 'name'
  | 'role'
  | 'title'
  | 'team'
  | 'supervisor'
  | 'assigned_entities'
  | 'status'
  | 'last_active';

const USER_TABLE_COLUMN_LABELS: Record<UserColumnKey, string> = {
  name: 'Name',
  role: 'Role',
  title: 'Title',
  team: 'Team',
  supervisor: 'Supervisor',
  assigned_entities: 'Assigned Entity',
  status: 'Status',
  last_active: 'Last Active',
};

const ALL_FIELDS = initialUserColumns.map(c => c.field) as UserColumnKey[];

export const UserTableColumnSelectionFilter = ({
  hideText,
}: {
  hideText?: boolean;
}) => {
  const hiddenColumns = useUserTableStore(s => s.hiddenColumns);
  const setHiddenColumns = useUserTableStore(s => s.setHiddenColumns);

  const columns: Partial<Record<UserColumnKey, ColumnPreferencesConfig>> =
    Object.fromEntries(
      ALL_FIELDS.map((field, index) => [
        field,
        {
          column_display: hiddenColumns.includes(field) ? 'hidden' : 'display',
          column_order: index,
          column_size: 160,
        } satisfies ColumnPreferencesConfig,
      ]),
    );

  const handleSelectionChange = (
    selection: Partial<Record<UserColumnKey, ColumnPreferencesConfig>>,
  ) => {
    setHiddenColumns(
      ALL_FIELDS.filter(field => selection[field]?.column_display === 'hidden'),
    );
  };

  return (
    <ColumnSelectionFilter
      name='user_table_columns'
      label='Columns'
      hideText={hideText}
      columns={columns}
      columnLabels={USER_TABLE_COLUMN_LABELS}
      onChange={handleSelectionChange}
      footerAction={
        <Button color='primary' onClick={() => setHiddenColumns([])}>
          RESET
        </Button>
      }
    />
  );
};
